import styled from '@emotion/styled/macro'

import { flexCenter } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const VerifyInfoFieldsWrapper = styled('div')`
  display: block;
  margin-bottom: 32px;
`

const VerifyInfoFieldsRow = styled('div')`
  ${flexCenter}

  flex-wrap: wrap;
  height: auto;
  justify-content: stretch;

  > .form-group {
    flex: 1 0 100%;

    :last-of-type {
      margin-bottom: 0;
    }
  }

  ${mediaQuery('', 'tablet')} {
    flex-wrap: nowrap;

    > .form-group {
      flex: 1;
      margin-bottom: 0;
    }

    > * + * {
      margin-left: 16px;
    }
  }

  :not(:last-of-type) {
    margin-bottom: 16px;
  }
`

export { VerifyInfoFieldsRow, VerifyInfoFieldsWrapper }
